import Vue from 'vue';

// 注册全局组件
import fetchMore from '../components/fetch-more';
import modal from '../components/modal';
import dialog from '../components/dialog';
import countdown from '../components/countdown';
import float from '../components/float';

Vue.component('v-fetch-more', fetchMore);
Vue.component('v-modal', modal);
Vue.component('y-dialog', dialog);
Vue.component('v-countdown', countdown);
Vue.component('v-float', float);